<script>
  export let size = 14;

  export let title = undefined;

  $: labelled = $$props["aria-label"] || $$props["aria-labelledby"] || title;
  $: attributes = {
    "aria-hidden": labelled ? undefined : true,
    role: labelled ? "img" : undefined,
  };
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="{size}"
  height="{size}"
  viewBox="0 0 14 14"
  fill="none"
  {...attributes}
  {...$$restProps}
>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M1.35 7.05011L7.2 12.9001L6.7 13.4001L0 6.70011L6.7 0.000106812L7.2 0.500107L1.35 6.35011H13.4V7.05011H1.35Z"
    fill="currentColor"></path>
</svg>
